import { render } from "./gameList.vue?vue&type=template&id=0c543634&scoped=true"
import script from "./gameList.vue?vue&type=script&lang=js"
export * from "./gameList.vue?vue&type=script&lang=js"

import "./gameList.vue?vue&type=style&index=0&id=0c543634&scoped=true&lang=css"

import exportComponent from "/Users/cole/Desktop/중요/xz_opr/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c543634"]])

export default __exports__